import { Injectable } from "@angular/core";

export interface MediaStatusDataValue {
  text: string;
  cssClass: string;
}

export interface MediaStatusData {
  DONE: Readonly<MediaStatusDataValue>;
  ERROR: Readonly<MediaStatusDataValue>;
  SUMMARIZING: Readonly<MediaStatusDataValue>;
  TRANSCRIBING: Readonly<MediaStatusDataValue>;
  TRANSLATING: Readonly<MediaStatusDataValue>;
  UPLOADING: Readonly<MediaStatusDataValue>;
}

export type MediaStatus = keyof MediaStatusData;

@Injectable({
  providedIn: "root",
})
export class MediaStatusDataService {
  readonly mediaStatusData: Readonly<MediaStatusData> = Object.freeze({
    DONE: Object.freeze({
      text: $localize`:@@media_status_data_done:Terminé`,
      cssClass: "status-done",
    }),
    ERROR: Object.freeze({
      text: $localize`:@@media_status_data_error:Erreur`,
      cssClass: "status-error",
    }),
    SUMMARIZING: Object.freeze({
      text: $localize`:@@media_status_data_summarization:Résumé`,
      cssClass: "status-summarizing",
    }),
    TRANSCRIBING: Object.freeze({
      text: $localize`:@@media_status_data_transcribing:Transcription`,
      cssClass: "status-transcripting",
    }),
    TRANSLATING: Object.freeze({
      text: $localize`:@@media_status_data_translating:Traduction`,
      cssClass: "status-translating",
    }),
    UPLOADING: Object.freeze({
      text: $localize`:@@media_status_data_uploading:Transfert`,
      cssClass: "status-uploading",
    }),
  });
}
